import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28b451bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, null, -1))
const _hoisted_3 = { class: "input" }
const _hoisted_4 = { class: "label" }
const _hoisted_5 = { class: "input" }
const _hoisted_6 = { class: "label" }
const _hoisted_7 = { class: "capcha-group" }
const _hoisted_8 = { class: "input" }
const _hoisted_9 = { class: "label" }
const _hoisted_10 = { class: "capcha" }
const _hoisted_11 = { class: "error" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bar-line" }, null, -1))
const _hoisted_13 = { class: "buttons" }
const _hoisted_14 = { class: "btn-label" }
const _hoisted_15 = { class: "label" }
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"footer\" data-v-28b451bb><div class=\"image-wrap\" data-v-28b451bb><div class=\"fc\" data-v-28b451bb></div><div class=\"ceza\" data-v-28b451bb></div></div><div class=\"footer-text\" data-v-28b451bb> 本公司领有菲律宾合法网上娱乐场牌照 (Interacrive Gaming Licence) Copyright 利博娱乐场 </div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_service = _resolveComponent("icon-service")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["login-root", { 'is-not-ipad': !_ctx.isIpadProDevice }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("form", {
        action: "",
        onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.accountLogin && _ctx.accountLogin(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.t('login.username')), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.uname) = $event))
          }, null, 512), [
            [_vModelText, _ctx.uname]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.t('login.password')), 1),
          _withDirectives(_createElementVNode("input", {
            type: "password",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pwd) = $event))
          }, null, 512), [
            [_vModelText, _ctx.pwd]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.t('login.verify')), 1),
            _withDirectives(_createElementVNode("input", {
              type: "number",
              inputmode: "numeric",
              onKeydown: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onCapchaKeydown && _ctx.onCapchaKeydown(...args))),
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.captcha) = $event))
            }, null, 544), [
              [_vModelText, _ctx.captcha]
            ])
          ]),
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.capchaInput), 1)
        ]),
        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.message), 1),
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", {
            class: "submit",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.accountLogin && _ctx.accountLogin(...args)))
          }, [
            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.t('login.submit')), 1)
          ])
        ])
      ], 32)
    ]),
    _createElementVNode("div", {
      class: "customer-service",
      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.contactService && _ctx.contactService(...args)))
    }, [
      _createVNode(_component_icon_service, {
        "fill-color": '#e0d77f',
        class: "icon"
      }),
      _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.t('menu.cutomerservice')), 1)
    ]),
    _createElementVNode("div", {
      class: "language",
      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.selectLanguage && _ctx.selectLanguage(...args)))
    }, _toDisplayString(_ctx.language), 1),
    _hoisted_16
  ], 2))
}